import Form from "react-bootstrap/Form";

type CheckboxProps = {
  label: string;
  handleCheck: (event) => void;
  name?: string;
  isInvalid?: boolean;
  isValid?: boolean;
  defaultChecked?: boolean;
  children?: React.ReactNode;
  className?: string;
};

export const Checkbox: React.FunctionComponent<CheckboxProps> = ({
  label,
  handleCheck,
  name,
  isInvalid,
  isValid,
  defaultChecked,
  children,
  className,
}) => {
  return (
    <div>
      <Form.Check
        type="checkbox"
        label={label}
        className={className}
        isInvalid={false}
        isValid={false}
        defaultChecked={defaultChecked}
        name={name}
        onClick={(e) => handleCheck(e)}
      />
    </div>
  );
};
